import { useNavigate } from "react-router-dom";
import {  FormDataStorage } from "../register/FormPage";
import { useEffect, useState } from "react";
import "./settings-style.css";
import "../register/form-layout.css";
import { Link } from "react-router-dom";

const SettingsPage = () => {
  const [titleAttentionText, setTitleAttentionText] = useState("");
  const [attentionDescriptionText, setAttentionDescriptionText] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const formData: FormDataStorage | null = JSON.parse(
      localStorage.getItem("formData") || "null"
    );

    if (formData) {
      setTitleAttentionText(formData.attentionText?.title || "");
      setAttentionDescriptionText(formData.attentionText?.description || "");
    }
  }, []);

  const handleSave = () => {
    const formData: FormDataStorage | null = JSON.parse(
      localStorage.getItem("formData") || "null"
    );
    if (formData) {
      formData.attentionText.title = titleAttentionText;
      formData.attentionText.description = attentionDescriptionText;
      localStorage.setItem("formData", JSON.stringify(formData));
    }

    navigate("/");
  };

  const handleCancel = () => {
    const formData: FormDataStorage | null = JSON.parse(
      localStorage.getItem("formData") || "null"
    );
    setAttentionDescriptionText("");
    setAttentionDescriptionText("");
    if (formData) {
      formData.attentionText.title = "";
      formData.attentionText.description = "";
      localStorage.setItem("formData", JSON.stringify(formData));
    }
    navigate("/");
  };

  return (
    <div
      className="prefs-page"
      style={{
        backgroundImage: `url(${require("../../assets/images/background-opacity.png")}), url(${require(`../../assets/images/wallpaper/${new Date().getDate()}.jpeg`)})`,
      }}
    >
      <div className="prefs-shell">
        <header className="prefs-header">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="prefs-back"
          >
            <i className="fas fa-chevron-left"></i> Kthehu
          </button>
          <h1>
            <i className="fas fa-bullhorn"></i> Lajmi Aktual
          </h1>
          <Link to="/form" className="prefs-save">
            <i className="fas fa-cog"></i> Preferencat e Xhamisë
          </Link>
        </header>

        <section className="prefs-card news-card">
          <div className="form-group">
            <label htmlFor="titleText">Titulli</label>
            <input
              id="titleText"
              type="text"
              value={titleAttentionText}
              onChange={(e) => setTitleAttentionText(e.target.value)}
              placeholder="Shkruaj titullin..."
            />
          </div>
          <div className="form-group">
            <label htmlFor="descriptionText">Përmbajtja</label>
            <textarea
              id="descriptionText"
              value={attentionDescriptionText}
              onChange={(e) => setAttentionDescriptionText(e.target.value)}
              className="news-textarea"
              placeholder="Shkruaj përmbajtjen..."
            />
          </div>
          <div className="news-actions">
            <button onClick={handleSave} className="prefs-save">
              <i className="fas fa-check"></i> Paraqit lajmin
            </button>
            <button onClick={handleCancel} className="news-clear">
              Fshije nga paraqitja
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};
export default SettingsPage;
